import React from 'react';
import { motion } from 'framer-motion';
import { BotIcon, UsersIcon, SparklesIcon, RocketIcon } from 'lucide-react';
import { useLanguage } from '../lib/i18n';
export function CrobotShowcase() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 md:py-32 px-6 md:px-12 lg:px-20 z-10 relative" data-id="element-147">
      <div className="max-w-[1400px] mx-auto" data-id="element-148">
        <div className="border-t border-border pt-16 md:pt-20" data-id="element-149">
          {/* Header */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="mb-14 md:mb-16" data-id="element-150">
            <div className="flex items-center gap-3 mb-4" data-id="element-151">
              <BotIcon className="w-4 h-4 text-secondary/60" data-id="element-152" />
              <p className="text-secondary text-xs tracking-[0.2em] uppercase font-light" data-id="element-153">
                {t.crobotOverline}
              </p>
            </div>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-display font-light text-primary tracking-tight mb-6 leading-snug" data-id="element-154">
              {t.crobotTitle}
            </h2>
            <p className="text-secondary text-base md:text-lg font-light max-w-2xl leading-relaxed" data-id="element-155">
              {t.crobotDesc}
            </p>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-156">
            {/* Left — Video */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7,
            ease: [0.16, 1, 0.3, 1]
          }} className="group block" data-id="element-157">
              <div className="relative overflow-hidden rounded-lg bg-surface border border-border/50" data-id="element-158">
                <div className="flex items-center gap-1.5 px-4 py-2.5 bg-surface border-b border-border/50" data-id="element-159">
                  <div className="w-2 h-2 rounded-full bg-white/10" data-id="element-160" />
                  <div className="w-2 h-2 rounded-full bg-white/10" data-id="element-161" />
                  <div className="w-2 h-2 rounded-full bg-white/10" data-id="element-162" />
                  <div className="ml-3 flex-1 h-4 rounded bg-white/5 max-w-[140px]" data-id="element-163" />
                </div>
                <div className="relative aspect-video overflow-hidden bg-[#0A0A0A]" data-id="element-164">
                  <video src="https://cdn.magicpatterns.com/uploads/nMVDh2auSFMWDftFjxTnV4/crobot.mp4" autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover object-[15%_center] transition-transform duration-700 ease-out group-hover:scale-[1.02]" data-id="element-165" />
                  <div className="absolute inset-0 bg-background/0 group-hover:bg-background/10 transition-colors duration-500 pointer-events-none" data-id="element-166" />
                </div>
              </div>
            </motion.div>

            {/* Right — Details */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7,
            delay: 0.15,
            ease: [0.16, 1, 0.3, 1]
          }} className="flex flex-col justify-center" data-id="element-167">
              <p className="text-secondary text-sm md:text-base font-light leading-relaxed mb-8" data-id="element-168">
                {t.crobotDetail}
              </p>

              <div className="grid grid-cols-3 gap-3 w-full" data-id="element-169">
                {[{
                icon: UsersIcon,
                value: '700+',
                label: t.crobotStat1
              }, {
                icon: SparklesIcon,
                value: '1st',
                label: t.crobotStat2
              }, {
                icon: RocketIcon,
                value: '100%',
                label: t.crobotStat3
              }].map((stat, i) => <motion.div key={stat.label} initial={{
                opacity: 0,
                y: 15
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.5,
                delay: 0.3 + i * 0.1,
                ease: [0.16, 1, 0.3, 1]
              }} className="flex flex-col items-start gap-3 p-4 rounded-xl border border-border/60 bg-surface/20" data-id="element-170">
                    <div className="w-8 h-8 rounded-full border border-border flex items-center justify-center shrink-0" data-id="element-171">
                      <stat.icon className="w-3 h-3 text-secondary/60" data-id="element-172" />
                    </div>
                    <div data-id="element-173">
                      <div className="text-lg font-display font-light text-primary tracking-tight leading-none mb-1" data-id="element-174">
                        {stat.value}
                      </div>
                      <div className="text-[10px] text-secondary/50 tracking-[0.12em] uppercase font-light leading-tight" data-id="element-175">
                        {stat.label}
                      </div>
                    </div>
                  </motion.div>)}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}